import React, { useState } from 'react'
import { useForm } from 'react-hook-form'
import { useHistory, useLocation, useParams } from 'react-router-dom'
import http from '../../../config/BaseUrl'
import LoginImage from '../../../assets/images/login.jpg'
import Logo from '../../../assets/images/logo/Haylo-logo-white.png'
import '../style/style.css'
import { useEffect } from 'react'

const EmailVerify = () => {
  const history = useHistory()
  const { code } = useParams()
  const [loading, setLoading] = useState(false)

  const verifyEmail = async () => {
    console.log(code)
    try {
      const userInfo = {
        email_verified_code: code,
      }
      setLoading(true)
      await http.post("email/verify", userInfo).then((res) => {
        let value = res.data.verify;
        let tokens = res.data.token;
        if (value.verify_status === "active") {
          localStorage.removeItem("token_verify");
          localStorage.removeItem("users");
          localStorage.removeItem("persist:root")
          setTimeout(() => {
            localStorage.setItem("token_verify", tokens);
            localStorage.setItem("users", JSON.stringify(value));
            setLoading(false)
            if (value.membership && value.membership.package_type === "trial") {
              history.go("/dashboard")
            }
            else {
              history.go("/event/type")
            }
          }, 1000)
        }

      }).catch((err) => {
        console.log(err.response.message);
        setLoading(false)
      })
    } catch (error) {

    }
  }

  useEffect(() => {
    verifyEmail()
  }, [code])




  return (
    <>

      <div className="p-3 section-authentication-login p-md-0">
        <div className="px-0 container-fluid">

          <div className="row h-100">
            <div className="col-md-6 d-none d-md-block">
              <div className="page-image">
                <div className="login-header">
                  <div className="logo">
                    <img src={Logo} className="img-fluid" alt="haylo" />
                  </div>

                </div>
                <div className="image-body">
                </div>
              </div>
            </div>
            <div className="col-md-6 col-12">
              <div className="form-body">
                <div className="row justify-content-center align-items-center h-100">
                  <div className="col-12">
                    {/* <p className="pr-5 text-right text-secodary font-weight-bold">Don’t have an account? <Link to="/register">Sign up now</Link></p> */}
                  </div>
                  <div className="col-md-7 col-sm-8 col-12">
                    <div className="mx-auto my-auto h-100">
                      <div className="p-md-3">
                        <div className="text-left">
                          <h3 className="mb-4 text-center font-weight-bold">Email Verifying</h3>
                        </div>

                        <div className="success-title">
                          <p className="mb-5 text-center text-secondary">The page will redirect in some moment {loading ? <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> : ''} </p>
                        </div>

                      </div>
                    </div>
                  </div>
                  <div className="col-12">
                    <p className="pr-5 text-right font-weight-bold"></p>
                  </div>
                </div>

              </div>
            </div>

          </div>
        </div>

      </div>

    </>
  )
}

export default EmailVerify
